import React from "react";
import { FiltersTypes } from "@common/types/filters/general";
import { useCurrentWorkspaceMembers } from "@api/workspaceMember.api";
import { formatWorkspaceMemberFilterLabel } from "@components/pageHeader/filters/workspaceMemberFilter.lib";

interface Props {
    filters: FiltersTypes;
}

export const TemplateCreatedByFilterLabel: React.FC<Props> = ({ filters }) => {
    const { data: members } = useCurrentWorkspaceMembers();

    const label = formatWorkspaceMemberFilterLabel({
        userIds: filters.invoiceTemplateCreatedByUserIds,
        members,
    });

    if (!label) {
        return null;
    }

    return <span>{label}</span>;
};
